import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-folder-heart-icon',
  templateUrl: './files-folder-heart.component.html'
})
export class FilesFolderHeartComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
